import PrivacyPolicy5 from './PrivacyPolicy5'
export default PrivacyPolicy5
